/**
 * Utility functions for the theme
 */

/**
 * Returns a function that as long as it continues to be invoked, won't be triggered.
 * @param {Function} fn - Callback function.
 * @param {number} [wait=300] - Delay (in milliseconds).
 * @returns {Function}
 */
window.debounce = function(fn, wait = 300) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

// Make debounce available in global scope
if (typeof debounce === 'undefined') {
  window.debounce = window.debounce;
  debounce = window.debounce;
}

// Details disclosure for cart drawer
window.DetailsDisclosure = class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.disclosure = this.querySelector('details');
    if (!this.disclosure) return;
    this.toggle = this.disclosure.querySelector('summary');
    this.panel = this.disclosure.querySelector('div');
    
    this.toggle.addEventListener('click', this.handleToggle.bind(this));
  }

  handleToggle(e) {
    e.preventDefault();
    
    if (this.disclosure.hasAttribute('open')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.disclosure.setAttribute('open', '');
    this.toggle.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.disclosure.removeAttribute('open');
    this.toggle.setAttribute('aria-expanded', 'false');
  }
}; 